module.exports = __webpack_public_path__ + "img/price-tag-3-fill.448e8ebf.svg";